import styled from "styled-components";

export const UserReportPageStyle = styled.div`
  .card-div {
    display: flex;
    align-self: center;
    margin-top: 50px;
  }

  .heading {
    font-size: 2.5vh;
  }

  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    background-color: #f28809;
  }
  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled {
    background-color: #f28809;
  }
  .calender-icon {
    color: #f28809;
    font-size: 23px;
  }

  .react-date-picker__wrapper {
    border: none;
  }

  .someUser-box {
    box-shadow: 0 0 15px rgba(247, 148, 29, 0.3);
    transition: box-shadow 0.3s ease;
    border-radius: 8px;
    border: 1px solid white;
    padding: 2vh 3.5vh;
    text-align: center;
    display: flex;
    flex-direction: column;
    width: 70vh;
    height: 500px;
    margin-top: 3vh;
    overflow-wrap: anywhere;
    align-self: center;
    overflow-y: scroll;
    font-family: thin-pro, sans-serif;
  }

  .search-bar {
    display: flex;
    align-items: center;
    border: 1px solid #f28809;
    border-radius: 20px;
    width: 100%;
    background-color: white;
    padding: 0 15px 0 5px;
    margin-bottom: 10px;
  }

  .search-input {
    flex: 1;
    border: none;
    outline: none;
    padding: 5px;
    border-radius: 20px;
  }

  .search-icon {
    color: #f28809;
    font-size: 20px;
    cursor: pointer;
  }

  .userCheck {
    display: flex;
    justify-content: space-between;
    margin-top: 5px;
    padding: 5px;
    border-radius: 5px;
    :hover {
      background-color: #ea9533;
      color: white;
    }
  }

  .selected-div {
    background-color: #f28809;
    color: white;
    display: flex;
    justify-content: space-between;
    margin-top: 5px;
    padding: 5px;
    border-radius: 5px;
  }
  .select-btn {
    background-color: #f28809;
    border-radius: 5px;
    font-size: 13px;
    color: white;
    border: 0px solid;
  }

  .input-field {
    height: 5vh;
    margin-bottom: 5px;
    font-family: thin-pro, sans-serif;
    width: 350px;
    align-self: center;
  }
`;
